<div [formGroup]="form" [ngSwitch]="control.controlType">

  <mat-form-field *ngSwitchCase="'textbox'" appearance="outline" [ngClass]="control.layout">
    <mat-label [attr.for]="control.key">{{ control.label }}</mat-label>
    <input [maxlength]="control.maxLength" matInput [formControlName]="control.key" [id]="control.key" [type]="control.type"
      (keydown)="preventSpace($event)" />
    <mat-error *ngIf="!isValid || form.get(control.key)?.hasError('isSpecialCharacters')">
      El campo no puede estar vacio, contener la letra ñ o caracteres especiales.
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="'email'" appearance="outline" [ngClass]="control.layout">
    <mat-label [attr.for]="control.key">{{ control.label }}</mat-label>
    <input matInput [formControlName]="control.key" [id]="control.key" [type]="control.type"
      (keydown)="preventSpace($event)" />
    <mat-error *ngIf="!isValid || form.get(control.key)?.hasError('isSpecialCharacters')">
      El campo no puede estar vacio o el email es incorrecto
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="'numberInput'" appearance="outline" [ngClass]="control.layout">
    <mat-label [attr.for]="control.key">{{ control.label }}</mat-label>
    <input matInput [min]="control.min" [max]="control.max" [formControlName]="control.key" [id]="control.key"
      [type]="control.type" />
    <mat-error *ngIf="!isValid">{{ control.label }} no es valido</mat-error>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="'dropdown'" appearance="outline" [ngClass]="control.layout">
    <mat-label [attr.for]="control.key">{{ control.label }}</mat-label>
    <mat-select [formControlName]="control.key" [(value)]="control.value" [id]="control.key" required>
      <mat-option *ngFor="let opt of control.options" [value]="opt.key">
        {{ opt.value }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="!isValid">{{ control.label }} no es valido</mat-error>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="'dropdownFees'" appearance="outline" [ngClass]="control.layout">
    <mat-label [attr.for]="control.key">{{ control.label }}</mat-label>
    <mat-select [formControlName]="control.key" [(ngModel)]="control.value" [id]="control.key" required>
      <mat-option *ngFor="let opt of control.options" [value]="opt.key">
        {{ opt.value }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="!isValid">{{ control.label }} no es valido</mat-error>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="'dropdownIdentification'" appearance="outline" [ngClass]="control.layout">
    <mat-label [attr.for]="control.key">{{ control.label }}</mat-label>
    <mat-select [compareWith]="compareFunction" [formControlName]="control.key" [id]="control.key" required>

      <mat-option *ngFor="let opt of control.optionsObject | async" [value]="opt.id">
        {{opt?.description }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="!isValid">{{ control.label }} no es valido</mat-error>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="'dropdownClients'" appearance="outline" [ngClass]="control.layout">
    <input matInput [formControl]="filterControl" placeholder="Buscar cliente" class="input-list"
      (input)="select.open()" />
    <mat-select #select [formControlName]="control.key" required>
      <mat-option *ngFor="let opt of filteredOptions" [value]="opt.id">
        {{ opt.partnerName }}
      </mat-option>
    </mat-select>

    <mat-error *ngIf="!isValid">{{ control.label }} no es válido</mat-error>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="'currency'" appearance="outline" [ngClass]="control.layout">
    <mat-label [attr.for]="control.key">{{ control.label }}</mat-label>
    <input matInput
      [formControlName]="control.key" [id]="control.key" [type]="control.type" appCurrencyMask />
    <mat-error *ngIf="form.get(control.key)?.hasError('isCurrency')">
      El monto mínimo permitido es 50,000. Por favor, ingrese un monto válido.
    </mat-error>
    <mat-error *ngIf="form.get(control.key)?.hasError('miniumQuota') == true">
      El monto supera su cupo disponible. Por favor, ingrese un monto válido.
    </mat-error>
    <mat-error *ngIf="form.get(control.key)?.hasError('buyMin') == true">
      El monto no supera el valor mínimo que financia el comercio.
    </mat-error>
    <mat-error *ngIf="form.get(control.key)?.hasError('buyMax') == true">
      El monto supera el valor maximo que financia el comercio.
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="'code'" appearance="outline" [ngClass]="control.layout">
    <mat-label [attr.for]="control.key">Código otp</mat-label>
    <input class="code" matInput placeholder="- - - -" [formControlName]="control.key" [id]="control.key"
      [type]="control.type" />
    <mat-error *ngIf="!isValid">{{ control.label }} no es válido</mat-error>
  </mat-form-field>

</div>